<template>
  <tr>
    <td class="text-center p-3">
      <strong style="font-size: 16px">{{
        $t('common_words.total_mayus')
      }}</strong>
    </td>
    <td class="text-center p-3">
      <strong style="font-size: 16px">{{ getTotalArea() }}</strong>
    </td>
    <td class="text-center" v-for="(ribbon, week) in columns" :key="week">
      <strong style="font-size: 16px">{{
        getTotalColumn(week, ribbon[0])
      }}</strong>
    </td>
    <td class="text-center">
      <strong style="font-size: 16px">{{ getTotal() }}</strong>
    </td>
  </tr>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';

export default {
  name: 'tfoot-totals',
  props: {
    totalCoveredAreas: {
      type: Number | String,
    },
    totalColumns: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    option: {
      type: String,
      default: 'byTotal',
    },
  },
  mixins: [MixinMasters],
  methods: {
    getTotalArea(format = true) {
      const result = this.totalCoveredAreas;
      return format ? Formatter.formatNumber(result) : result;
    },
    getTotalColumn(week, ribbon) {
      const result = Object.values(
        this.totalColumns[week][ribbon.color_name]
      ).map((totalColumn) =>
        Array.isArray(totalColumn)
          ? getSumOfValorFromArray(totalColumn)
          : totalColumn
      );

      const sum = getSumOfValorFromArray(result);
      if (['byTotalHa', 'byLotsHa'].includes(this.option)) {
        const totalArea = this.getTotalArea(false);
        return sum > 0 && Number(totalArea) > 0
          ? Formatter.formatNumber(sum / Number(totalArea))
          : '0';
      }
      return sum > 0 ? Formatter.formatNumber(sum) : '';
    },
    getTotal() {
      let total = 0;
      Object.values(this.totalColumns)
        .map((totalColumn) => Object.values(totalColumn))
        .forEach((values) => {
          Object.values(values[0]).forEach((items) => {
            total += Array.isArray(items)
              ? getSumOfValorFromArray(items)
              : items;
          });
        });

      if (['byTotalHa', 'byLotsHa'].includes(this.option)) {
        const totalArea = this.getTotalArea(false);
        return total > 0 && Number(totalArea) > 0
          ? Formatter.formatNumber(total / Number(totalArea))
          : '0';
      }

      return total > 0 ? Formatter.formatNumber(total) : '';
    },
  },
};
</script>
